import { setCookie } from '@cian/utils/lib/browser/cookie';

import { SESSION_MY_HOME_HOMEOWNER_TRAP_KEY } from './constants';

export const setCloseCookies = () => {
  const currentDate = new Date();
  const dateThroughOneYear = new Date(currentDate.setFullYear(currentDate.getFullYear() + 1));

  setCookie(SESSION_MY_HOME_HOMEOWNER_TRAP_KEY, `1`, {
    expires: dateThroughOneYear,
    secure: false,
  });
};
